
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { styledTab, styledTabs, useStyles } from './ManuallyEnterTabs.styles'
import Text from '../Text'

const StyledTabs = withStyles(styledTabs)((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

const StyledTab = withStyles(styledTab)((props) => <Tab disableRipple {...props} />)

export default function ManuallyEnterTabs({ value, handleChange }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <StyledTabs
        value={value} 
        onChange={handleChange}
        aria-label="manually add data"    
      >
        <StyledTab label={<Text size='subnote' >Net Promoter Score (NPS)</Text>} />
      </StyledTabs>
    </div>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          { children }
        </>
      )}
    </div>
  )
}
  
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

export { TabPanel }